import * as t from 'io-ts';

export const integrationPropertyCodec = t.type({
  name: t.string,
  category: t.union([t.null, t.string]),
  prismatic_id: t.string,
  overview: t.union([t.null, t.string]),
  enabled: t.boolean,
});

export const listCodec = t.array(integrationPropertyCodec);

export const integrationPropertyDetailedCodec = t.type({
  name: t.string,
  category: t.union([t.null, t.string]),
  prismatic_id: t.string,
  help_center_url: t.union([t.null, t.string]),
  overview: t.union([t.null, t.string]),
  activation_instruction: t.union([t.null, t.string]),
  about: t.union([t.null, t.string]),
  enabled: t.boolean,
});
